module.exports = __webpack_public_path__ + "img/cta-no-promo.45df52e2.png";